import { render } from "./VerifyOTP.vue?vue&type=template&id=62f14d5f"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"
script.render = render

export default script